import { Component } from '@angular/core';

import { useDispatcher } from '../../../store.decorator';
import { ChatStatusService } from '../../core';

import { TranslationKeyMap } from './chat-menu-dialog.i18n';
import { ChatMenuDialogService } from './chat-menu-dialog.service';
import { ChatNav } from './model/chat-nav.model';
import { minMax } from './state/min-max.action';

@Component({
    selector: 'cmps-teamscall-chat-menu-dialog',
    templateUrl: './chat-menu-dialog.component.html',
    host: {
        class: 'cmps-teamscall-chat-menu-dialog',
        '[class.cmps-cdk-h-auto]': '_service.state?.minimized',
    },
})
export class ChatMenuDialogComponent {
    /** @private */
    _i18n = TranslationKeyMap;
    /** @private */
    _ChatNav = ChatNav;

    constructor(
        /* keep */ private readonly _statusService: ChatStatusService,
        /** @private */ readonly _service: ChatMenuDialogService,
    ) {}

    /** @private **/
    _onMinMaxClick(): void {
        useDispatcher(
            this._service,
            minMax({ minimized: !(this._service.state?.minimized ?? false) }),
        );
    }
}
